// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8764) return "static/chunks/8764-9371850932cabeaa.js";
	if (chunkId === 2221) return "static/chunks/2221-61e54de856dc0bcf.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"4824":"906a09f8","5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"4824":"f7d1685159a52192","5224":"599f7b393a5b9c08","5443":"00ac8a0de35f16f7","6350":"88a0a3f3a652a0dd","7679":"40ce7e70d74c37ae","7856":"12e1598fc530fcca","8362":"2a83ecd0ccf0a1c3","9894":"2158f83293bf6448"}[chunkId] + ".js";
};